<template>
  <div class="askQuestion" v-if="question_list[index]">
    <!-- <div class="header">
      <div class="week">
        {{week_info.week_text || ''}}·{{week_info.knowledge || ''}}·第{{timesCN}}次作业
      </div>
      <div class="questionId">题目 ID：{{question_list[index].no}}</div>
    </div>-->
    <header-info
      :week_info="week_info"
      :question_list="question_list"
      :index="index"
      :timesCN="timesCN"
    ></header-info>
    <div class="mes">
      <div class="mes-left">
        <div class="left-header">
          <div class="header-number" style="display:flex;align-items:center">
            第
            <span style="display:block;margin:auto 16px;">{{index+1}}</span>题
          </div>
          <div class="header-audio">
            <div @click="switchAudioPlay" :class="{'audio-switch': true, 'off': !isAudioSwitchOn}">
              <div class="switch-item"></div>
            </div>
            <div class="audio-info">语音读题</div>
          </div>
        </div>
        <div class="left-footer">{{question_list[index].desc}}</div>
      </div>
      <div class="mes-right" @click="showRelusModel">
        <img src="../assets/imgs/question/rules.png" alt />
      </div>
    </div>
    <van-popup class="success-full-screen" @close="rightAnswer" v-if="isRight" v-model="show">
      <div @click="closeRight" class="right-imgs"></div>
    </van-popup>
    <van-dialog
      v-if="!isRight"
      v-model="show"
      show-confirm-button
      show-cancel-button
      cancel-button-text="重做本题"
      cancel-button-color="#7DB9FF"
      confirm-button-text="下一题"
      confirm-button-color="#333333"
      :before-close="wrongAnswer"
    >
      <div class="wrong-imgs"></div>
      <div class="wrong-title">呜呜~回答错误！</div>
      <div class="wrong-desc">加油，再想想哦~争取答对</div>
    </van-dialog>
    <!--做题-->
    <div class="answers">
      <img src="../assets/imgs/question/prev.png" @click.stop="toLastQuestion" />
      <div class="answers-choose">
        <!-- 单选题 -->
        <test-one :question="question_list[index]" :reload="reload" @getResult_test="getResult"></test-one>
      </div>
      <img src="../assets/imgs/question/next.png" @click.stop="toNextQuestion" />
    </div>
    <!-- 下标回答状态 -->
    <div class="body-footer">
      <div @click="goIndex(i)" class="body-footer-item" v-for="(item,i) in question_list " :key="i">
        {{i+1}}
        <template v-if="typeof item.right === 'boolean'">
          <img class="right" v-if="item.right" src="../assets/imgs/question/isright.png" />
          <img class="wrong" v-if="!item.right" src="../assets/imgs/question/iswrong.png" />
        </template>
        <img class="index" v-if="index==i" src="../assets/imgs/question/isindex.png" />
      </div>
    </div>
    <Rules :text="rules_text" v-if="ruleModeShow" @close="closeRelus"></Rules>
    <Score v-if="isScoreActive" :score="score" :onClose="handleScoreClose"></Score>
  </div>
</template>

<script>
import * as Api from '../api/index'
import testOne from '@/components/testOne.vue'
import Rules from '@/components/rules.vue'
import headerInfo from '@/components/headerInfo.vue'
import Score from '@/components/score.vue'

export default {
  name: 'askQuestion',
  data() {
    return {
      index: 0, // 当前题目下标 默认为0
      week_info: {},
      question_list: [],
      isRight: false,
      show: false,
      has: true,
      isAudioSwitchOn: true,
      desc: '', // 打谱的sgf格式字符
      type: '', // 当前题目类型---3做题
      student_answer: '', // 学生答案
      reload: 0, // 是否刷新页面
      rules_text: '本次作业共5题，每题5分。要及时改正错误哦。左右箭头可以选择题目。',
      ruleModeShow: false,
      isScoreActive: false,
      score: 0
    }
  },
  components: {
    testOne,
    Rules,
    headerInfo,
    Score
  },
  computed: {
    timesCN() {
      const { times } = this.$route.params
      // eslint-disable-next-line no-nested-ternary
      return times === '1' ? '一' : times === '2' ? '二' : times === '3' ? '三' : '四'
    }
  },
  mounted() {
    // 结果数组
    this.resultList = []

    this.$rightPlayer = new Audio(window.mp3.rightAnswerMp3)
    this.$wrongPlayer = new Audio(window.mp3.wrongAnswerMp3)

    this.$readPlayer = new Audio()

    this.init()

    document.addEventListener(
      'WeixinJSBridgeReady',
      e => {
        // play然后马上暂停，提前去加载音频
        this.$rightPlayer.play()
        this.stopRightPlayer()
        this.$wrongPlayer.play()
        this.stopWrongPlayer()

        this.playAudio(this.audioContents[0].url)
      },
      false
    )
  },
  watch: {
    index() {
      this.catchVideo()
    }
  },
  methods: {
    // 初始化数据---题目详情
    async init() {
      const { week, times } = this.$route.params
      const res = await Api.getQuestionList({
        week,
        times: times - 1,
        type: 'x'
      })

      if (res.status === 0) {
        const question_ids = []

        const { question_list, week_info } = res.content

        question_list.forEach(ele => {
          question_ids.push(ele.question_id)
        })

        const audios = await Api.getQuestionAudioAll({
          questionIds: question_ids.join(',')
        })

        this.audioContents = audios.content
        this.question_list = question_list
        this.week_info = week_info
        this.$store.dispatch('changLoadingStatus', false)
      }
    },
    // 跳到任意题
    goIndex(i) {
      this.index = i
      this.reload = this.reload + 1
    },

    handleScoreClose() {
      this.isScoreActive = false
      wx.miniProgram.navigateBack()
    },

    switchAudioPlay() {
      this.isAudioSwitchOn = !this.isAudioSwitchOn
    },

    stopRightPlayer() {
      this.$rightPlayer.pause()
      this.$rightPlayer.currentTime = 0
    },

    stopReadPlayer() {
      this.$readPlayer.pause()
      this.$readPlayer.currentTime = 0
    },

    stopWrongPlayer() {
      this.$wrongPlayer.pause()
      this.$wrongPlayer.currentTime = 0
    },

    playAudio(src) {
      this.$readPlayer.src = src
      this.$readPlayer.play()
    },

    closeRight() {
      this.show = false
      this.stopRightPlayer()
    },

    catchVideo() {
      this.isAudioSwitchOn && this.playAudio(this.audioContents[this.index].url)
    },

    // 显示作业要求model
    showRelusModel() {
      this.ruleModeShow = true
    },
    // 关闭规则说明
    closeRelus() {
      this.ruleModeShow = false
    },
    // 上一个问题
    toLastQuestion() {
      if (this.index === 0) {
        // this.$toast('当前已是第一个问题')
      } else {
        this.index -= 1
        this.reload = this.reload + 1
      }
    },
    // 下一个问题
    toNextQuestion() {
      const { length } = this.question_list
      if (this.index === length - 1) {
        this.score = this.resultList.filter(val => val === true).length * 5
        this.isScoreActive = true
      } else {
        this.index += 1
        this.reload = this.reload + 1
      }
    },
    // 获取答案正确与否
    getResult(data) {
      this.stopReadPlayer()
      this.student_answer = data.data // 学生答案
      if (data.desc === '正确') {
        this.$rightPlayer.play()
        this.setRightError(true)
        this.isRight = true
        this.show = true
        this.submitHomeworkData(0)
        setTimeout(() => {
          this.closeRight()
          this.resultList[this.index] = true
          this.toNextQuestion()
        }, 1000)
      } else {
        this.$wrongPlayer.play()
        this.setRightError(false)
        this.isRight = false
        this.show = true
        this.submitHomeworkData(1)
      }
    },
    // right or error
    setRightError(type) {
      this.$set(this.question_list, this.index, {
        ...this.question_list[this.index],
        right: type
      })
    },
    // 错误答案的事件
    wrongAnswer(action, done) {
      this.stopWrongPlayer()

      if (action === 'confirm') {
        this.resultList[this.index] = false
        this.toNextQuestion()
      } else {
        this.reload = this.reload + 1
      }
      done()
    },
    // 正确答案的事件
    rightAnswer(action, done) {
      if (action === 'confirm') {
        this.resultList[this.index] = true
        this.toNextQuestion()
        done()
      }
    },
    // 提交数据 -- 问答 --回答正确
    submitHomeworkData(isright) {
      const { week, times } = this.$route.params
      const params = {
        week,
        times: times - 1, // 这需要-1 才能匹配到第几次
        question_id: this.question_list[this.index].question_id,
        is_right: isright,
        is_x_type: 1,
        student_answer: this.student_answer,
        type: 'x', // 作业项目类型--2 3 6 x
        question_type: 1 // 题目真正的类型
      }
      Api.answer(params).then(res => {
        if (res.status === 0) {
          console.log(res)
        } else {
          this.$toast(res.msg)
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.askQuestion {
  width: 100%;
  height: 100vh;
  background: #fff5da;
  .header {
    width: 100%;
    height: halvePx(80);
    background: rgba(244, 229, 194, 1);
    display: flex;
    align-items: center;
    line-height: halvePx(80);
    padding: halvePx(40);
    .week {
      font-size: halvePx(28);
      font-family: PingFang-SC-Regular;
      font-weight: 400;
    }
    .questionId {
      flex: 1;
      text-align: right;
      font-size: halvePx(28);
      font-family: PingFang-SC-Medium;
      font-weight: 500;
    }
  }
  .mes {
    width: halvePx(670);
    height: halvePx(155);
    display: flex;
    align-items: center;
    margin: auto;
    .mes-left {
      flex: 1;
      height: 100%;
      .left-header {
        font-size: halvePx(28);
        font-family: PingFang-SC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin: halvePx(30) auto;
        display: flex;
        align-items: center;
        span {
          display: inline-block;
          width: halvePx(40);
          height: halvePx(50);
          line-height: halvePx(50);
          background: rgba(244, 229, 194, 1);
          text-align: center;
        }
      }
      .left-footer {
        font-size: halvePx(30);
        font-family: PingFang-SC-Medium;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }
    }
    .mes-right {
      img {
        width: halvePx(110);
        height: halvePx(110);
      }
    }
  }
  .answers {
    width: halvePx(670);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: halvePx(86) auto 0;
    img {
      display: inline-block;
      width: halvePx(44);
      height: halvePx(60);
    }
    .answers-choose {
      flex: 1;
      height: auto;
      .choose-item {
        width: halvePx(540);
        height: halvePx(100);
        background: rgba(250, 229, 179, 1);
        border: halvePx(2) solid rgba(196, 178, 135, 1);
        border-radius: halvePx(50);
        font-size: halvePx(30);
        font-family: PingFang-SC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: halvePx(100);
        text-align: center;
        margin: halvePx(20);
      }
    }
  }
  // .body-footer{
  //   width:100%;
  //   height:auto;
  //   display:flex;
  //   justify-content:center;
  //   align-items: center;
  //   flex-wrap:wrap;
  //   margin-left:halvePx(40);
  //   margin-top:halvePx(30);
  //   position: absolute;
  //   bottom:0;
  //   .body-footer-item{
  //     width:halvePx(62);
  //     height:halvePx(62);
  //     background:#F4E5C2;
  //     border:halvePx(4) solid #fff;
  //     border-radius:50%;
  //     margin-right:halvePx(30);
  //     margin-bottom:halvePx(20);
  //     font-size:halvePx(28);
  //     line-height:halvePx(62);
  //     text-align:center;
  //     color:#A08C5E;
  //     position: relative;
  //     .right,.wrong{
  //       width:halvePx(34);
  //       height:halvePx;
  //       position: absolute;
  //       bottom:halvePx(-10);
  //       right:halvePx(-10);
  //     }
  //     .index{
  //       width:halvePx(21);
  //       height:halvePx(19);
  //       position: absolute;
  //       left:halvePx(20);
  //       top:halvePx(-10);
  //     }
  //   }
  // }
  .body-footer {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    position: absolute;
    bottom: halvePx(20);
    .body-footer-item {
      width: halvePx(60);
      height: halvePx(60);
      background: #f4e5c2;
      border: halvePx(4) solid #fff;
      border-radius: 50%;
      margin: halvePx(10) halvePx(10);
      font-size: halvePx(28);
      line-height: halvePx(52);
      text-align: center;
      color: #a08c5e;
      position: relative;

      .right,
      .wrong {
        width: halvePx(34);
        height: halvePx;
        position: absolute;
        bottom: halvePx(-10);
        right: halvePx(-10);
      }

      .index {
        width: halvePx(21);
        height: halvePx(19);
        position: absolute;
        left: halvePx(15);
        top: halvePx(-10);
      }
    }
  }
}
.right-img {
  width: halvePx(80);
  height: halvePx(80);
  display: block;
  margin: halvePx(20) auto;
}
.right-text {
  width: 100%;
  margin: halvePx(10) auto;
  text-align: center;
}
</style>
